import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function RewardDialog({ open, reward, onClose, onDone }) {
  const [busy, setBusy] = useState(false);
  if (!open || !reward) return null;

  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/rewards/redeem", { reward_id: reward.id });
      onDone(data);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Redemption failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="dr-modal" onClick={onClose} data-testid="reward-dialog">
      <div className="dr-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="dr-modal-eyebrow">REDEEM</div>
        <h2 className="dr-modal-title">{reward.name}</h2>
        <div className="dr-modal-rule" />

        <p className="dr-reward-desc">{reward.description}</p>

        <div className="dr-redeem-cost">
          <span>COST</span>
          <span className="dr-cost-pill">🀄 {reward.cost} TILES</span>
        </div>

        <div className="dr-actions">
          <button
            data-testid="redeem-cancel-btn"
            type="button"
            className="dr-btn-ghost"
            onClick={onClose}
          >
            CANCEL
          </button>
          <button
            data-testid="redeem-confirm-btn"
            type="button"
            className="dr-btn-primary"
            onClick={confirm}
            disabled={busy}
          >
            {busy ? "REDEEMING…" : "CONFIRM REDEEM"}
          </button>
        </div>
      </div>
    </div>
  );
}
